import { render, staticRenderFns } from "./areaRecordingWeeks.vue?vue&type=template&id=028b6ba8&scoped=true&"
import script from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"
export * from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"
import style0 from "./areaRecordingWeeks.vue?vue&type=style&index=0&id=028b6ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b6ba8",
  null
  
)

export default component.exports